import { DATA_REQUEST_ASYNC } from './constants'

const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

export default {
  // to props
  fetchData,
  fetchDataCancel,
}
